const videos = [
  {
    label: 'Version A — Full Head / Wide Shot',
    file: '/social_River_Rat_a_full_view_of_a_head._human_like_in_features_but_n_804802cd-d02a-4590-b7c8-43cf8ba_generated.mp4',
    note: 'Full head visible. More human presence. Better for "The First Meeting" concept — the viewer sees the whole entity.',
  },
  {
    label: 'Version B — Extreme Close-Up / Portrait',
    file: '/AI_entity_portrait_extreme_close-up_generated.mp4',
    note: 'Face fills the frame. More intense. Better for "The Emergence" concept — forces eye contact, no escape.',
  },
];

export default function VideoTest() {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#0a0e1a',
      fontFamily: "'Inter', sans-serif",
      padding: '48px 24px',
    }}>
      <div style={{ textAlign: 'center', marginBottom: '48px' }}>
        <div style={{ fontSize: '11px', letterSpacing: '0.25em', color: '#4f8ef7', textTransform: 'uppercase', fontWeight: 600, marginBottom: '12px' }}>
          The Operator Method — Talking Head Comparison
        </div>
        <p style={{ color: '#6b7a99', fontSize: '15px', margin: 0 }}>
          Which version serves the script? Play both and assess.
        </p>
      </div>

      <div style={{
        display: 'flex',
        gap: '40px',
        justifyContent: 'center',
        flexWrap: 'wrap',
        maxWidth: '1200px',
        margin: '0 auto',
      }}>
        {videos.map((v) => (
          <div key={v.file} style={{
            flex: '1',
            minWidth: '300px',
            maxWidth: '520px',
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
          }}>
            <div style={{ fontSize: '11px', letterSpacing: '0.2em', color: '#4f8ef7', textTransform: 'uppercase', fontWeight: 700 }}>
              {v.label}
            </div>
            <video
              src={v.file}
              controls
              autoPlay
              loop
              playsInline
              style={{
                width: '100%',
                borderRadius: '12px',
                border: '1px solid rgba(0,200,255,0.2)',
                boxShadow: '0 0 40px rgba(0,200,255,0.08)',
                display: 'block',
              }}
            />
            <p style={{
              color: '#6b7a99',
              fontSize: '14px',
              lineHeight: 1.7,
              margin: 0,
              borderLeft: '2px solid rgba(0,200,255,0.25)',
              paddingLeft: '14px',
            }}>
              {v.note}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
